import { Injectable } from '@angular/core';
import { environment } from '#environments/environment';
import { HttpClient } from '@angular/common/http';
import { FunctionalReviewDetails } from 'functional-review/models/functional-review-details';
import { catchError, tap } from 'rxjs/operators';
import { of } from 'rxjs';
import { FunctionalReviewDTO } from 'functional-review/models/functional-review-dto';

@Injectable({
  providedIn: 'root'
})
export class FunctionalReviewService {
  constructor(private http: HttpClient) {
  }

  loadFunctionalReview(reviewTypeId: number, mocId: number, frChecklistRecordId: number) {
    return this.http.get<FunctionalReviewDetails>(
      `${environment.apiEndpoint}/fr/functional-reviews`, {
      params: {
        reviewTypeId: `${reviewTypeId}`,
        mocId: `${mocId}`,
        frChecklistRecordId: `${frChecklistRecordId}`
      }
    }
    ).pipe<FunctionalReviewDetails>(
      catchError(() => {
        return of(null);
      })
    );
  }
  completeReview(id: number) {
    return this.http.put<FunctionalReviewDTO>(
      `${environment.apiEndpoint}/fr/functional-reviews/${id}/complete`, {
    }
    );
  }

  start(payload: Partial<FunctionalReviewDTO>) {
    return this.http.post<FunctionalReviewDetails>(
      `${environment.apiEndpoint}/fr/functional-reviews`,
      payload
    );
  }
  getReport(ID: number, reportName = 'FR.xlsx') {
    return this.http.get<Blob>(
      `${environment.apiEndpoint}/fr/functional-reviews/${ID}/report`,

      { responseType: 'blob' as 'json' }
    ).pipe(
      tap((data) => {

        if (window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(data, reportName);
        } else {
          const link = document.createElement('a');
          link.href = window.URL.createObjectURL(data);
          link.download = reportName;
          link.click();
        }
      })
    );
  }

}
